var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 10.6667L14 8M14 8L11.3333 5.33333M14 8L4.66667 8M8.66667 10.6667V11.3333C8.66667 12.4379 7.77124 13.3333 6.66667 13.3333H4C2.89543 13.3333 2 12.4379 2 11.3333V4.66666C2 3.56209 2.89543 2.66666 4 2.66666H6.66667C7.77124 2.66666 8.66667 3.56209 8.66667 4.66666V5.33333",
    stroke: "#6B7496",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.6494a07aec5e241b48e0ed74e3f8e269.svg";
export { ForwardRef as ReactComponent };